import React, { useEffect, useState } from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { useProfile } from '../../hooks/use-profile';
export var DashboardHeading = function () {
    var _a = useState(), firstName = _a[0], setFirstName = _a[1];
    var profileValues = useProfile();
    var getProfileData = profileValues.getProfileData;
    useEffect(function () {
        getProfileData().then(function (profileData) {
            if (profileData.firstName)
                setFirstName(profileData.firstName);
        });
    }, [getProfileData]);
    return (React.createElement(Typography, { variant: "h2", weight: "display" },
        firstName && (React.createElement(React.Fragment, null,
            "Welcome Back, ",
            React.createElement("span", { "data-qm-mask": "" }, firstName))),
        !firstName && 'Welcome Back'));
};
